import {
  isStudioRegistration,
} from "./StudioRegistration";


export const STUDIO_CATALOG_FALLBACK_ICON = "🧩";


export function createStudioCatalogEntry(
  registration
) {
  if (!isStudioRegistration(registration)) {
    throw new TypeError(
      "StudioCatalog requires a valid StudioRegistration."
    );
  }

  const metadata =
    registration.metadata || {};

  const title =
    metadata.title
    || registration.id;

  const description =
    metadata.description
    || "";

  const icon =
    metadata.icon
    || STUDIO_CATALOG_FALLBACK_ICON;

  const status =
    metadata.status
    || "available";

  return Object.freeze({
    id: registration.id,
    domainId:
      metadata.domainId
      || metadata.domain
      || null,
    title,
    description,
    icon,
    category:
      metadata.category
      || null,
    status,
    panelMode:
      registration.panelMode,
    registration,
  });
}


export function createStudioCatalog(
  registrations = []
) {
  if (!Array.isArray(registrations)) {
    throw new TypeError(
      "StudioCatalog registrations must be an array."
    );
  }

  return Object.freeze(
    registrations.map(
      createStudioCatalogEntry
    )
  );
}


export function createStudioAdminActions(
  registrations = [],
  {
    tab = "studio",
  } = {}
) {
  return createStudioCatalog(registrations)
    .map((entry) => Object.freeze({
      tab,
      id: entry.id,
      domainId: entry.domainId,
      icon: entry.icon,
      title: entry.title,
      description: entry.description,
      category: entry.category,
      status: entry.status,
      action: Object.freeze({
        type: "panel",
        panelMode: entry.panelMode,
      }),
    }));
}
